import { values } from '../_helpers'

const _enum = {
  low: 0,
  medium: 1,
  deep: 2,
}

const colourIntensity = { ..._enum, name: 'colourIntensity', values: values(_enum) }

export {
  colourIntensity
}
